<script lang="ts">
	import type { SeoMetaTagData } from '@tools/cms';
	import { ensureTitleSuffix } from '@tools/meta';
	import { page } from '$app/stores';

	const { tags = [], suffix }: { tags?: SeoMetaTagData[]; suffix?: string | null } = $props();

	const adjustedTags = $derived(ensureTitleSuffix(tags, suffix));
</script>

<svelte:head>
	{#each adjustedTags as { tag, attributes, content }}
		<!--
			NOTE: We don't use the <svelte:element> setup because of
			svelte 5 SSR fragments being output as comments in all HTML elements,
			including <title>, <script>, and <style>, which breaks everything

			{#if content}
				<svelte:element this={tag} {...attributes}>{@html content}</svelte:element>
			{:else}
				<svelte:element this={tag} {...attributes} />
			{/if}
		-->
		<!-- eslint-disable-next-line svelte/no-at-html-tags -->
		{@html `<${tag} ${
			attributes
				? Object.keys(attributes)
						?.map((key) => `${key}="${attributes?.[key]}"`)
						.join(' ')
				: ''
		} ${content ? `>${content}</${tag}>` : `/>`}`}
	{/each}
	<link
		rel="canonical"
		href={`https://www.musikhuset.dk${$page.url.pathname}${$page.url.pathname === '/kalender' ? $page.url.search : ''}`}
	/>
</svelte:head>
